<template>
  <div class="flex tab-wrapper">
    <div
      v-for="({ name, id, displayName }, i) in tabs"
      :key="id"
      class="
        relative
        w-1/5
        px-12
        py-3
        text-neutral-75
        bg-neutral-0
        cursor-pointer
        transition-all
        duration-500
        hover:text-primary-main
        hover:bg-white
        hover:shadow-primary"
      :class="[
        i === activeIndex && 'active-tab',
        i === 0 && 'first-tab',
        i === tabs.length - 1 && 'last-tab',
        (i > 0 && i < tabs.length - 1) && 'middle-tabs',
        i === Math.floor(tabs.length / 2) && 'center-tab',
        name + '_t',
      ]"
      @click="handleClick(name, i)"
    >
      <div class="flex flex-col items-center">
        <component :is="tabIcon(name)" class="text-current" />
        <p class="mt-1 text-current whitespace-nowrap">
          {{ changeCase(displayName, ElementE.TITLE) }}
        </p>
      </div>
      <div v-if="i === activeIndex" class="absolute -bottom-[7px] left-1/2 -translate-x-1/2">
        <TabArrowDownIcon />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import GeneralTabIcon from "../icons/GeneralTabIcon.vue";
import PropertiesTabIcon from "../icons/PropertiesTabIcon.vue";
import DisplayTabIcon from "../icons/DisplayTabIcon.vue";
import StyleTabIcon from "../icons/StyleTabIcon.vue";
import PreviewTabIcon from "../icons/PreviewTabIcon.vue";
import TabArrowDownIcon from "../icons/TabArrowDownIcon.vue";
import { TabI, tabs } from "./constants";
import { changeCase } from "../../helpers";
import { ElementE } from '../../enums'

export default defineComponent({
  name: "TabMenuNew",
  components: {
    GeneralTabIcon,
    PropertiesTabIcon,
    DisplayTabIcon,
    StyleTabIcon,
    PreviewTabIcon,
    TabArrowDownIcon,
  },
  props: {
    activeIndex: {
      type: Number,
      default: 0
    },
  },
  emits: ["sendTabId"],

  data() {
    return {
      tabs: [] as TabI[],
      
      changeCase: changeCase,
      ElementE: ElementE,
    };
  },

  mounted() {
    this.tabs = tabs;
  },

  methods: {
    handleClick(tabName: string, index: number) {
      this.$emit("sendTabId", {tabName, index});
    },

    tabIcon(iconName: string) {
      switch (iconName) {
        case "general":
          return GeneralTabIcon;

        case "properties":
          return PropertiesTabIcon;

        case "display":
          return DisplayTabIcon;

        case "style":
          return StyleTabIcon;

        case "preview":
          return PreviewTabIcon;
      }
    },
  },
});
</script>
